import { render, staticRenderFns } from "./product.vue?vue&type=template&id=389d567e"
import script from "./product.vue?vue&type=script&lang=js"
export * from "./product.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {Img: require('/vercel/path0/components/ui/img.vue').default,Rating: require('/vercel/path0/components/ui/rating.vue').default,Counter: require('/vercel/path0/components/ui/counter.vue').default})
